<template>
  <transition name="modal" v-if="videoView != null">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="row t-a-center">
            <h3 class="title text-white t-a-center">
            {{ videoView.Title }}
            </h3>
            <video
              preload="metadata"
              width="100%"
              controls
              :title="'Video - ' + videoView.Media.url"
            >
              <source
                :src="baseUrl + videoView.Media.url"
                :type="videoView.Media.mime"
              />
            </video>
            <a v-on:click.stop.prevent="closeModal()" class="btn btn-dark btn-theme-colored btn-sm">CHIUDI</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: table;
  transition: opacity 0.7s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 70%;
  margin: 0px auto;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<script>
export default {
  name: "VideoModal",
  props: ["videoView"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods:{
    closeModal(){
        this.$emit("closeModal");
    }
  },
};
</script>
